import { render, staticRenderFns } from "./PurchaseFailed.vue?vue&type=template&id=8ad840b4&scoped=true&"
import script from "./PurchaseFailed.vue?vue&type=script&lang=js&"
export * from "./PurchaseFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad840b4",
  null
  
)

export default component.exports